import React from 'react';
import { TacticalLabel } from './TacticalLabel';
const missions = [{
  code: 'MISSION-2401',
  title: 'Full AC Replacement',
  location: 'Chandler',
  desc: '4-ton Daikin Fit, Manual J resized.',
  img: 'https://cdn.magicpatterns.com/uploads/mmAC8uA7TnpbaLBxriGjif/sapper-central.png'
}, {
  code: 'MISSION-2387',
  title: 'Aurus Mini-Split Install',
  location: 'Gilbert',
  desc: '18K BTU side-discharge unit. Tight clearance install.',
  img: 'https://cdn.magicpatterns.com/uploads/obRxp5LZBdZiPfqBFsZV3F/sapper-mini.png'
}, {
  code: 'MISSION-2356',
  title: 'Compressor Service Call',
  location: 'Scottsdale',
  desc: 'Refrigerant gauge diagnostics. Sealed system verified.',
  img: 'https://cdn.magicpatterns.com/uploads/qmZZHhjLHPQa6mZ2Ff6HZq/sapper-compressor.png'
}];
export function CaseFiles() {
  return <section id="missions" className="py-24 bg-sapper-dark relative" data-id="element-22">
      <div className="container mx-auto px-4 sm:px-6" data-id="element-23">
        <div className="mb-16" data-id="element-24">
          <TacticalLabel className="mb-4" data-id="element-25">
            CASE FILE // RECENT DEPLOYMENT
          </TacticalLabel>
          <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight" data-id="element-26">
            RECENT MISSIONS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-27">
          {missions.map(mission => <div key={mission.code} className="group flex flex-col bg-[#141A15] border border-sapper-olive/30 overflow-hidden" data-id="element-28">
              <div className="relative aspect-video overflow-hidden" data-id="element-29">
                <div className="absolute inset-0 bg-sapper-olive/20 mix-blend-multiply z-10 group-hover:opacity-0 transition-opacity duration-500" data-id="element-30" />
                <img src={mission.img} alt={mission.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" data-id="element-31" />
                <div className="absolute top-4 left-4 z-20 bg-sapper-dark/90 px-3 py-1 border border-sapper-olive/50" data-id="element-32">
                  <span className="font-mono text-xs text-sapper-red font-bold tracking-widest" data-id="element-33">
                    {mission.code}
                  </span>
                </div>
              </div>

              <div className="p-8 flex-grow flex flex-col" data-id="element-34">
                <h3 className="font-condensed font-bold text-2xl text-sapper-white uppercase tracking-wide mb-2" data-id="element-35">
                  {mission.title}
                </h3>
                <div className="font-mono text-xs text-sapper-gray mb-4 tracking-wider" data-id="element-36">
                  LOC: {mission.location.toUpperCase()}
                </div>
                <p className="font-sans text-sapper-gray text-sm mb-8 flex-grow" data-id="element-37">
                  {mission.desc}
                </p>
                <a href="#contact" className="inline-flex items-center font-mono text-xs text-sapper-red font-bold tracking-widest hover:text-white transition-colors mt-auto" data-id="element-38">
                  &gt; READ FILE
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}